import { EndpointBuilder } from "@reduxjs/toolkit/query";
import { HTTP_METHODS } from "@src/constants";
import { baseApiSlice } from "@src/services/apis/baseApiSlice";
import { Employee, SapCsvData } from "@src/types";
import { message } from "antd";

export const adminApi = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* POST endpoints */
    ...postEndpoints(builder),
  }),
});

function postEndpoints(builder: EndpointBuilder<any, any, any>) {
  const baseMethod = HTTP_METHODS.POST;
  return {
    checkDeletedSapData: builder.mutation<SapCsvData[], string[]>({
      query: (sapData) => ({
        url: "/admin/check-deleted-employees",
        method: baseMethod,
        body: sapData,
      }),
      transformErrorResponse: async () => {
        message.error("Check deleted employees", 5);
      },
    }),
    checkSapData: builder.mutation<SapCsvData[], SapCsvData[]>({
      query: (sapData) => ({
        url: "/admin/check-sap-data",
        method: baseMethod,
        body: sapData,
      }),
      transformErrorResponse: async () => {
        message.error("Check sap data", 5);
      },
    }),

    saveSAPData: builder.mutation<Employee[], SapCsvData[]>({
      query: (sapDataToSave) => ({
        url: "/admin/save-sap-data",
        method: baseMethod,
        body: sapDataToSave,
      }),
    }),
  };
}

export const {
  /* POST endpoints */
  useCheckSapDataMutation,
  useSaveSAPDataMutation,
  useCheckDeletedSapDataMutation,
} = adminApi;
